export function MSFinancialsTab(ms) {
  return (
    <>
      <div>MS Financials</div>
    </>
  );
}
